import { DeviceOrientation } from '../../shared/enum/device-orientation.enum';
import { IStoreUiState } from './ui.interface';

export default {
  uiOrientation: DeviceOrientation.PORTRAIT,
  users: [],
  programs: [],
  downloadedVideo: [],
  dialogTrapStack: [],
  notificationTrapStack: []
} as IStoreUiState;
